export const THEME_PRESETS = {
  'legacy-dark': {
    id: 'legacy-dark',
    label: 'Legacy Dark',
    vars: {
      '--bg': '#1a1a1a',
      '--bg-deep': '#0f0f0f',
      '--card': '#111827',
      '--ink': '#ffffff',
      '--muted': '#9ca3af',
      '--line': '#374151',
      '--accent': '#dc2626', // Tailwind red-600-ish
      '--accent-2': '#ef4444'
    }
  },
  'sand': {
    id: 'sand',
    label: 'Sand',
    vars: {
      '--bg': '#f7f3eb',
      '--bg-deep': '#efe7d9',
      '--card': '#fffaf1',
      '--ink': '#1f2933',
      '--muted': '#5f6b7a',
      '--line': 'rgba(31, 41, 51, 0.12)',
      '--accent': '#ff8a00',
      '--accent-2': '#2a9d8f'
    }
  },
  'midnight': {
    id: 'midnight',
    label: 'Midnight',
    vars: {
      '--bg': '#0b1220',
      '--bg-deep': '#070b13',
      '--card': '#0f1a2e',
      '--ink': '#e5e7eb',
      '--muted': '#9ca3af',
      '--line': 'rgba(148, 163, 184, 0.18)',
      '--accent': '#60a5fa',
      '--accent-2': '#a78bfa'
    }
  },
  'mono': {
    id: 'mono',
    label: 'Mono',
    vars: {
      '--bg': '#0b0b0b',
      '--bg-deep': '#000000',
      '--card': '#111111',
      '--ink': '#f5f5f5',
      '--muted': '#bdbdbd',
      '--line': '#2a2a2a',
      '--accent': '#f5f5f5',
      '--accent-2': '#bdbdbd'
    }
  }
};

export const DEFAULT_THEME_ID = 'legacy-dark';

export function listThemePresets() {
  return Object.values(THEME_PRESETS).map(({ id, label }) => ({ id, label }));
}
